if (!customElements.get('marquee-bar')) {
  customElements.define(
    'marquee-bar',
    class MarqueeBar extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.marquee-bar__track');
        this.content = this.querySelector('.marquee-bar__content');
        if (!this.track || !this.content) return;

        this.speed = parseFloat(this.dataset.speed) || 35; // px per second

        this.setup();

        // Re-measure once the display font has loaded (text width changes on
        // font swap, which would otherwise misalign the seamless loop seam).
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.setup.bind(this));
        }
        window.addEventListener('load', this.setup.bind(this));

        // Re-measure on resize so it always fills the viewport seamlessly.
        var timer;
        window.addEventListener('resize', function () {
          clearTimeout(timer);
          timer = setTimeout(this.setup.bind(this), 200);
        }.bind(this));
      }

      setup() {
        // Remove any previously added clones.
        this.track.querySelectorAll('[data-marquee-clone]').forEach(function (clone) {
          clone.remove();
        });

        var containerWidth = this.clientWidth;
        var copyWidth = this.content.getBoundingClientRect().width;
        if (copyWidth === 0) return;

        // Enough copies to always cover the viewport plus one full set,
        // so shifting by exactly one set-width loops with no gap or jump.
        var copiesNeeded = Math.ceil(containerWidth / copyWidth) + 1;
        for (var i = 0; i < copiesNeeded; i++) {
          var clone = this.content.cloneNode(true);
          clone.setAttribute('data-marquee-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        }

        this.track.style.setProperty('--marquee-distance', '-' + copyWidth + 'px');
        this.track.style.setProperty('--marquee-duration', (copyWidth / this.speed).toFixed(2) + 's');
      }
    }
  );
}
